import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { UseGoogleReviewsResult } from './types';
import { reactQueryConfigs } from '@/src/core/providers/ReactQueryProvider/configs';

type Options = UseQueryOptions<
  UseGoogleReviewsResult,
  unknown,
  UseGoogleReviewsResult
>;

// const placeId = 'ChIJ71KCno9zhlQRtqZld7g432U';
// const apiKey = 'AIzaSyBpN6YgvG8c08SCLsylupe8xBqtAd6ZRTI';
// const url = `https://maps.googleapis.com/maps/api/place/details/json?place_id=${placeId}&fields=rating,user_ratings_total&key=${apiKey}`;

export const fetchGoogleReviews = async () => {
  // const response: AxiosResponse<UseGoogleReviewsResult> = await callGetApi(
  //   url,
  //   undefined,
  //   { baseUrlType: 'direct' }
  // );

  // const { data } = response ?? {};
  const data = {
    html_attributions: [],
    result: { rating: 4.7, user_ratings_total: '+1100' },
    status: 'OK',
  };
  if (data?.status?.toLowerCase() === 'ok') {
    return data;
  } else {
    throw new Error('your request encountered an error');
  }
};

export const googleReviewsQueryKey = ['googleapis', 'reviews'];

export function useGoogleReviews(options?: Options) {
  return useQuery(googleReviewsQueryKey, fetchGoogleReviews, {
    ...options,
    staleTime: options?.staleTime ?? reactQueryConfigs.staleTime,
    cacheTime: options?.cacheTime ?? reactQueryConfigs.cacheTime,
  });
}
